import { useCallback, useState } from 'react';

/**
 * Creates a local boolean state and wraps the update with a toggle for ease of use.
 * @param initialValue Initial state value. Defaults to `false`.
 * @returns An array containing the current state value and method to toggle the value.
 */
export function useToggle(initialValue = false): [boolean, () => void] {
	const [ value, setValue ] = useState(initialValue);

	const toggle = useCallback(() => setValue((current) => !current), []);

	return [ value, toggle ];
}
